import { FC } from 'react'

import { useNavigate } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from 'src/Hooks/redux'
import {
  clearSubscriptionFromLocation,
  getSubscriptionFromLocation,
} from 'src/Redux/subscription-process/subscriptionFromLocation'

import { Container, Text, SubTitle } from '../../styles'
import { HeaderTitle } from '../HeaderTitle'

import { DescriptionWrapper, List, ListItem, NumberItem } from './styles'

export const InfoHeader: FC = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const fromLocation = useAppSelector(getSubscriptionFromLocation)
  const handleClose = (): void => {
    if (fromLocation) {
      navigate(fromLocation)
      dispatch(clearSubscriptionFromLocation())
      return
    }
    navigate('/')
  }
  return (
    <Container>
      <HeaderTitle onClose={handleClose}>
        Subscribe Your Account for Ongoing Benefits
      </HeaderTitle>

      <DescriptionWrapper>
        <Text>
          Opt for a monthly deposit instead of one-time payments for hassle-free
          campaign launches. Unlock the loyalty program for cashback with each
          campaign.
        </Text>
      </DescriptionWrapper>

      <List>
        <ListItem>
          <NumberItem>1</NumberItem>
          <div>
            <SubTitle>Choose Your Plan</SubTitle>
            <Text>
              Align with your promotional needs and enjoy the convenience of a
              monthly charge on the same recurring date.
            </Text>
          </div>
        </ListItem>
        <ListItem>
          <NumberItem>2</NumberItem>
          <div>
            <SubTitle>Monthly Balance Boost</SubTitle>
            <Text>
              The subscription amount will be added to your balance every month.
              Use it to effortlessly launch new campaigns with cashback bonuses.
            </Text>
          </div>
        </ListItem>
        <ListItem>
          <NumberItem>3</NumberItem>
          <div>
            <SubTitle>Flexible Usage</SubTitle>
            <Text>
              Your balance stays intact, whether you launched a campaign this
              month or not, waiting to support your promo strategy.
            </Text>
          </div>
        </ListItem>
      </List>
    </Container>
  )
}
